import {ICarLocation} from '../../models/CarLocation'
import {Locale} from '../config/constants'
import {getValueByLocale} from './util'

export const localizeCarLocation = (locale: Locale, carLocation: ICarLocation) => {
  const {
    name, nameEn,
    address, addressEn,
    region, regionEn,
    prefecture, prefectureEn,
    description, descriptionEn,
    nearestStation, nearestStationEn
  } = carLocation
  return {
    ...carLocation,
    description: getValueByLocale(locale, description, descriptionEn),
    name: getValueByLocale(locale, name, nameEn),
    nearestStation: getValueByLocale(locale, nearestStation, nearestStationEn),
    basicAddress: [
      getValueByLocale(locale, prefecture, prefectureEn),
      getValueByLocale(locale, region, regionEn),
    ].join(locale === Locale.ja ? '' : ' '),
    fullAddress: [
      getValueByLocale(locale, prefecture, prefectureEn),
      getValueByLocale(locale, region, regionEn),
      getValueByLocale(locale, address, addressEn),
    ].join(locale === Locale.ja ? '' : ' ')
  }
}

export const getFullAddress = (carLocation: ICarLocation) => {
  const { prefecture, region, address } = carLocation
  return `${prefecture}${region}${address}`
}
